"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mfDiff = mfDiff;
const mf_parser_1 = require("mf-parser");
function mfDiff(mfString1, mfString2) {
    let mf1 = new mf_parser_1.MF(mfString1).getInfo().atoms;
    let mf2 = new mf_parser_1.MF(mfString2).getInfo().atoms;
    let atoms = Object.keys(mf1);
    for (const atom of Object.keys(mf2)) {
        if (!atoms.includes(atom))
            atoms.push(atom);
    }
    let mf = '';
    for (let atom of atoms) {
        let diff = (mf1[atom] || 0) - (mf2[atom] || 0);
        if (diff)
            mf += atom + diff;
    }
    return new mf_parser_1.MF(mf).toMF();
}
//# sourceMappingURL=mfDiff.js.map